export const CONSTANTS = {
  PAGE_SIZE_OPTIONS: [25, 50, 100],
  TABLE_NO_DATA: 'No data found',
  PRIVACY_POLICY_URL: 'https://www.alphastarav.com/en/PrivacyPolicy.aspx',
  BE_DATE_FORMAT: 'YYYY-MM-DD',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm:ss',
};
